import React, { Component } from "react"
import styled from "styled-components"

const TermsBox = styled.div`
  padding: 48px 0;
  max-width: 80rem;
  margin: 0 auto;

  @media (min-width: 768px) {
    padding: 64px 0;
  }
`

const Terms = styled.div`
  margin: 0 auto;
  max-width: 1280px;
  width: 90%;
`

const Header = styled.h1`
  font-size: 36px;
  font-family: "Poppins-SemiBold";
  color: #5225ee;
  @media (min-width: 768px) {
    font-size: 48px;
  }
`

const Divider = styled.hr`
  margin-top: 16px;
  margin-bottom: 16px;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`

const TermHeader = styled.h3`
  margin-bottom: 16px;
  font-family: "Poppins-Medium", sans-serif;
  color: #5225ee;
  font-size: 18px;
`

const TermP = styled.p`
  margin: 0 0 16px;
  font-size: 1rem;
  line-height: 1.5;
  color: #474c72;
`

const TermList = styled.ul`
  padding-left: 18px;
`

const ListItem = styled.li`
  margin-bottom: 1.5rem;
`

const Strong = styled.strong`
  font-family: "Poppins-SemiBold";
`

export default class extends Component {
  render() {
    return (
      <TermsBox>
        <Terms>
          <Header>Privacy Policy</Header>
          <TermHeader>Highlights</TermHeader>

          <TermList>
            <ListItem>
              <TermP>
                We take your privacy very seriously as our goal is to provide
                everyone who visits our website and uses our Service with an
                incredible experience.
              </TermP>
            </ListItem>
            <ListItem>
              <TermP>
                We only collect certain information about you, your family, or
                your ward so that we can optimize your experience and process
                payments.
              </TermP>
            </ListItem>
            <ListItem>
              <TermP>
                We understand that, at times, it can be scary to disclose your
                personal information so we will do everything in our power to
                ensure that your data is stored safely and securely.
              </TermP>
            </ListItem>
          </TermList>
          <Divider></Divider>
          <TermHeader>User Consent</TermHeader>
          <TermP>
            By using this website, you are consenting to Codehall's Privacy
            Policy. You should only use Codehall's website and Service if you
            agree with the terms of this Privacy Policy and our{" "}
            <a href="https://www.codehall.ca/terms-of-service/">
              <u>Terms of Service</u>
            </a>
            .
          </TermP>
          <TermHeader>Parental Consent </TermHeader>
          <TermP>
            Our website is not meant to sell products or services to children
            and we do not knowingly solicit or collect personal information from
            children. If you are under the age of 18, you may only use the
            website with the supervision of your parent or guardian. By
            registering a minor and/or providing access to your account, you
            certify that you are the parent (or legal guardian) of the minor and
            agree to provide consent on behalf of said minor. We respect your
            privacy and your data; therefore, parents (or guardians) can
            withdraw this consent at any time. In the unlikely event that you
            find Codehall is collecting information from a minor without
            parental consent, please contact us immediately at
            support@codehall.ca and we will delete the data.&nbsp;
          </TermP>
          <TermHeader>What We Collect</TermHeader>

          <TermP>
            <Strong>Just what we need. </Strong>When you visit our website or
            register for/use our Service, we collect three types of information.
            Some of this information (as indicated when relevant), is required
            to manage our operations. Other information, such as demographic
            information and child interests, is optional and you only need to
            provide it if you wish. We use this information to better understand
            and serve our customers.
          </TermP>
          <ul>
            <li>
              <TermP>
                <Strong>1) Information that you provide us directly, </Strong>
                such as:
              </TermP>
              <ul>
                <li>
                  <TermP>Parent or guardian information</TermP>
                  <ul>
                    <li>
                      <TermP>Names</TermP>
                    </li>
                    <li>
                      <TermP>Phone numbers&nbsp;</TermP>
                    </li>
                    <li>
                      <TermP>Emails addresses</TermP>
                    </li>
                  </ul>
                </li>
                <li>
                  <TermP>Student information&nbsp;</TermP>
                  <ul>
                    <li>
                      <TermP>Date of Birth</TermP>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <TermP>
                <Strong>
                  2) Information that is collected automatically,{" "}
                </Strong>
                such as IP address and cookies, which digital identifiers,
                received by our server from your browser, that allow our website
                to recognize your computer or mobile devices as you log in or
                out and move between different pages. You may be able to change
                the settings of your browser to limit your device’s acceptance
                of cookies, but this may prevent you from properly using our
                Service. We collect and aggregate such data to understand usage
                patterns and traffic on our website, but this data cannot be
                used to identify you personally. If using a mobile app, we might
                collect mobile device ID.
              </TermP>
            </li>
            <li>
              <TermP>
                <Strong>
                  3) Recordings of all online sessions
                </Strong>{" "}
                for the security of the kids, training of our team, and quality
                assurance for everyone. We securely store these recordings and
                do not share them with anyone outside of our organization.
              </TermP>
            </li>
          </ul>

          <TermP>
            <Strong>Last updated: September 2, 2020</Strong>
          </TermP>
        </Terms>
      </TermsBox>
    )
  }
}
